import { styled } from "@mui/system";
import {
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  Accordion as MuiAccordion,
} from "@mui/material";

export const AccordionSummary = styled(MuiAccordionSummary)(({ styles }) => ({
  backgroundColor: "var(--container-light)",
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  ".MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
    color: "var(--text-primary)",
  },

  ...styles,
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ styles }) => ({
  backgroundColor: "var(--container-light)",
  color: "var(--text-primary)",
  borderBottomLeftRadius: "8px",
  borderBottomRightRadius: "8px",
  ...styles,
}));

export const Accordion = styled(MuiAccordion)(({ styles }) => ({
  backgroundColor: "var(--container-light)",
  color: "var(--text-primary)",
  borderRadius: "8px",
  "MuiAccordion-root:before": {
    content: "none",
  },
  ...styles,
}));
